import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const magicLogin = (token) =>
  requestSdk(() => post(`${BASE_URL}/v1/auth/magic-login/`, { token }));
